import Header from '../../components/students components/Home/Header';
import WhyUseTele from '../../components/students components/Home/WhyUseTele';
import SubjectPanel from '../../components/students components/Home/SubjectPanel';
import StatisBar from '../../components/students components/Home/StatisBar';
import Footer from '../../components/students components/Home/Footer';

const Home = () => {
  return (
    <div>
      <Header />

      <WhyUseTele />

      <SubjectPanel />

      <StatisBar />

      {/* <Footer /> */}
    </div>
  );
};

export default Home;
